// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum EscalationTypeEnum {
  SiemensMaterial = 0,
  SiemensAtMaterial = 1,
  OutsideMaterial = 2,
  MechanicalMaterial = 3,
  ElectricalMaterial = 4,
  PMLabor = 5,
  EngLabor = 6,
  GrapLabor = 7,
  ProgLabor = 8,
  SpecLabor = 9,
  DdepLabor = 10,
  MechLabor = 11,
  ElecLabor = 12,
}
